import { Injectable } from '@angular/core';
import { firebaseConfig2 } from './app.firebase.config';
import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class VsingService {

  second;
   
  constructor() {
    this.second = firebase.initializeApp(firebaseConfig2, 'secondary')
  }

  firebase2() {
    return this.second
  }
}
